module.exports = __webpack_public_path__ + "img/page-break.0126001d.svg";